import { render, staticRenderFns } from "./compChannelList.vue?vue&type=template&id=512b94f6"
import script from "./compChannelList.vue?vue&type=script&lang=js"
export * from "./compChannelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports